import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Skeleton = ({ classNames, height, width, borderRadius, minWidth }) => {
  return (
    <div
      className={cn(classNames, 'animate-pulse bg-secondary-50')}
      style={{ height: height, width: width, minWidth: minWidth, borderRadius: borderRadius }}
    />
  );
};

Skeleton.propTypes = {
  classNames: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  borderRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Skeleton.defaultProps = {
  borderRadius: 0
};

export default Skeleton;
